module.exports = __webpack_public_path__ + "media/images/Icon-cancel-done-94d7f58a72da4474df400dfb0e3f5ac5.svg";